import React from 'react';
import Avatar, { AvatarPropTypes } from './Avatar';

interface CompanyAvatarProps extends  AvatarPropTypes{
  company?: {
    website?: string;
    name?: string;
    logoUrl?: string;
  }
  website?: string;
}
const CompanyAvatar: React.FC<CompanyAvatarProps> = (props) => {
  const { company } = props;
  let { website} = props;
  website = company?.website || website;
  let src = website? `https://logo.accountingbox.nl?website=${website}` : '';

  if (company?.logoUrl) {
    src = company?.logoUrl;
  }

  if (!src && company?.name) {
    src = `https://logo.accountingbox.nl?name=${encodeURIComponent(company?.name)}`;
  }

  return (
    <Avatar src={src} {...props} name={company?.name} />
  );
};

export default CompanyAvatar;
